import { apiClient } from '../apiClient';
import { AuditLogDto } from '@shared/contracts';

export const auditApi = {
  getLogs: (): Promise<AuditLogDto[]> => {
    return apiClient.get<AuditLogDto[]>('/audit');
  },
};
